var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards-section__block",class:_vm.NamedBlockClass},[_c('div',{staticClass:"cards-section__block-wrapper"},[(_vm.named)?_vm._t("block-name"):_vm._e(),_c('AppGrid',[_vm._t("default")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }